<!--  -->
<template>
  <div class="deliver">
    <HomeNav></HomeNav>
    <PhoneNav></PhoneNav>
    <CrumbsNav :crumbsnav="crumbsnav"></CrumbsNav>
    <div class="deliver-main">
      <div class="personal">
        <el-input v-model="name" :placeholder="xm"></el-input>
        <el-input v-model="e_mail" :placeholder="yx"></el-input>
        <el-input v-model="phone" :placeholder="dh"></el-input>
      </div>

      <div class="box-select">
        <el-select v-model="value" :placeholder="qxzqzgw"
          ><!--岗位选项-->
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-select v-model="value1" :placeholder="qxzxzyq"
          ><!--薪资选项-->
          <el-option
            v-for="item in options1"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <el-input
        class="jybg"
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 8 }"
        :placeholder="jybj"
        v-model="educational"
      >
      </el-input>
      <el-input
        class="gzjl"
        type="textarea"
        :autosize="{ minRows: 4, maxRows: 12 }"
        :placeholder="gzjl"
        v-model="experience"
      >
      </el-input>

      <el-upload
        ref="upload"
        :limit="fileLimit"
        :on-remove="handleRemove"
        :on-error="onError"
        :file-list="fileList"
        :auto-upload="false"
        :http-request="uploadFile"
        action="https://jsonplaceholder.typicode.com/posts/"
        class="upload-demo"
      >
        <el-button slot="trigger" size="small" type="primary">{{
          scjl
        }}</el-button>
        <!-- <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button> -->
        <div slot="tip" class="el-upload__tip">
          {{ zcscgs }}
        </div>
      </el-upload>

      <div class="sumbit" @click="submitUpload">
        <span>{{ submit }}</span>
      </div>
    </div>
    <BottomNav></BottomNav>
  </div>
</template>

<script>
import HomeNav from "../components/HomeNav.vue";
import PhoneNav from "../components/PhoneNav.vue";
import CrumbsNav from "../components/CrumbsNav.vue";
import BottomNav from "../components/BottomNav.vue";

import { strRebuild, lastSubstring } from "../js/strUtil";
import { message } from "../js/message";
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    HomeNav,
    PhoneNav,
    CrumbsNav,
    BottomNav,
    strRebuild,
    lastSubstring,
    message,
  },
  data() {
    //这里存放数据
    return {
      xm: "",
      yx: "",
      dh: "",
      qxzqzgw: "", //请选择求职岗位
      qxzxzyq: "", //请选择薪资要求
      jybj: "", //教育背景
      gzjl: "", //工作经历
      scjl: "", //上传简历
      zcscgs: "",
      sumbit: "", //提交

      gangwei: 0,

      crumbsnav: [],

      options: [
        /* 
        {
          value: "1",
          label: "as",
        },
        {
          value: "2",
          label: "asfasfas",
        },
        {
          value: "3",
          label: "asfasfasf",
        },
        {
          value: "4",
          label: "zxcasd",
        },
        {
          value: "5",
          label: "asdfads",
        },
       */
      ],
      options1: [
        /* 
        {
          value: "1",
          label: "6000",
        },
        {
          value: "2",
          label: "8000",
        },
        {
          value: "3",
          label: "10000",
        },
        {
          value: "4",
          label: "12000",
        },
        {
          value: "5",
          label: "20000",
        },
       */
      ],
      fileList: [],
      // 允许的文件类型
      fileType: ["doc", "docx", "zip", "rar", "pdf", "jpg", "png"],
      // 运行上传文件大小，单位 M
      fileSize: 20,
      // 附件数量限制
      fileLimit: 1,
      value: "",
      value1: "",
      name: "",
      e_mail: "",
      phone: "",
      educational: "",
      experience: "",

      id: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    clear() {
      // 清空附件
      this.$refs.upload.clearFiles();
    },

    // 附件检查
    // 检查附件是否属于可上传类型
    // 检查附件是否超过限制大小
    checkFile() {
      var flag = true;
      var tip = "";
      var files = this.$refs.upload.uploadFiles;
      files.forEach((item) => {
        // 文件过大
        if (
          this.size !== null &&
          this.size !== "" &&
          item.size > this.fileSize * 1024 * 1024
        ) {
          flag = false;
          tip = "Upload attachments no more than " + this.fileSize + "M";
        }
        // 文件类型不属于可上传的类型
        if (
          this.fileType !== null &&
          this.fileType !== "" &&
          !this.fileType.includes(lastSubstring(item.name, "."))
        ) {
          flag = false;
          tip = "The format of the uploaded attachment is incorrect";
        }
      });
      if (!flag) {
        message("error", tip);
      }
      return flag;
    },

    // 提交附件
    submitUpload() {
      if (this.checkFile()) {
        console.log("上传附件...");
        this.$refs.upload.submit();
      } else {
        console.log("取消上传");
      }
    },

    //得到薪资
    get_config() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_config",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            var salary = obj.data[18].value.split(",");

            $.each(salary, function (i, k) {
              that.options1.push({
                value: k,
                label: k,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },

    // 自定义文件上传方法
    uploadFile(file) {
      // 把文件放入 FormData 进行提交
      console.log(file);
      const that = this;
      var formData = new FormData();
      formData.append("act", "yingpin");
      formData.append("username", that.name);
      formData.append("position", that.value);
      formData.append("mobile", that.phone);
      formData.append("email", that.e_mail);
      formData.append("salary", that.value1);
      formData.append("education", that.educational);
      formData.append("record", that.experience);
      formData.append("file", file.file); //上传单个图片
      
      console.log("cc");
      console.log(file.file);
      console.log("dd");

      if (that.name == "") {
        alert("Please fill in your name!");
        return false;
      }

      if (!that.e_mail.match(/^[\w\-\.]+@[\w\-\.]+(\.\w+)+$/)) {
        alert("Please fill in the correct email address!");
        return false;
      }

      if (that.phone == "") {
        alert("Please fill in the telephone number!");
        return false;
      }

      if (that.value == "") {
        alert("Please select a position!");
        return false;
      }

      if (that.value1 == "") {
        alert("Please select salary requirement!");
        return false;
      }

      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        //url: "/test.php",
        type: "post",
        datatype: "json",
        data: formData,
        processData: false,
        contentType: false,
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            //alert(obj.message);
            //location.href = "/dist/#/joinUs";
          } else {
            alert(obj.message);
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });

      // 请求接口 上传文件  data="param"
    },

    // 移除附件
    handleRemove(file, fileList) {
      console.log("移除附件...");
    },

    // 附件上传失败，打印下失败原因
    onError(err) {
      message("error", "Attachment upload failed");
      console.log(err);
    },

    // 字符串重组
    strRebuild(str) {
      return strRebuild(str);
    },

    //面包屑
    get_mianbao() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        async: false,
        data: {
          act: "get_all_nav_parent",
          nid: 5,
          showlast: 1,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.crumbsnav = [];
            $.each(obj.data, function (i, k) {
              that.crumbsnav.push({
                title: k.title,
                url: k.url,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },

    //文字翻译
    get_fanyi() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        data: {
          act: "get_fanyi",
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            that.xm = obj.data["xm"];
            that.yx = obj.data["yx"];
            that.dh = obj.data["dh"];
            that.qxzqzgw = obj.data["qxzqzgw"];
            that.qxzxzyq = obj.data["qxzxzyq"];
            that.jybj = obj.data["jybj"];
            that.gzjl = obj.data["gzjl"];
            that.scjl = obj.data["scjl"];
            that.zcscgs = obj.data["zcscgs"];
            that.submit = obj.data["tj"];
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },

    //岗位列表
    get_gangwei() {
      const that = this;
      $.ajax({
        url: "/index.php?s=Home/Api/get_data",
        type: "get",
        datatype: "json",
        async: false,
        data: {
          act: "article_list",
          category_id: 49,
        },
        success: function (ret) {
          var obj = JSON.parse(ret); //json数据转为数组
          if (obj.code == "0000") {
            $.each(obj.data, function (i, k) {
              that.options.push({
                value: k.id,
                label: k.title,
              });
            });
          }
        },
        error: function (err) {
          console.log("ajax错误");
        },
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.id = this.$route.query.id;
    this.value = this.$route.query.id;

    this.get_mianbao();
    this.get_fanyi();
    this.get_gangwei();
    this.get_config();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};

function parseUrl() {
  var url = location.href;
  var i = url.indexOf("?");
  if (i == -1) return;
  var querystr = url.substr(i + 1);
  var arr1 = querystr.split("&");
  var arr2 = new Object();
  for (i in arr1) {
    var ta = arr1[i].split("=");
    arr2[ta[0]] = ta[1];
  }
  return arr2;
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../scss/public";
.deliver-main {
  width: $main-width;
  margin: 70px auto;
  .personal {
    display: flex;
    justify-content: space-between;
    margin: 20px auto;
    .el-input {
      width: 32%;
      height: 60px;
    }
    .el-input >>> .el-input__inner {
      height: 60px;
      line-height: 60px;
      color: #c1c1c1;
      font-size: 1.2rem;
    }
  }
  .box-select {
    display: flex;
    justify-content: space-between;
    .el-select {
      width: 48%;
      height: 60px;
      .el-input {
        height: 60px;
      }
    }
    .el-select >>> .el-input__inner {
      height: 60px;
      color: #c1c1c1;
      font-size: 1.2rem;
    }
  }

  .jybg {
    margin: 20px auto;
  }

  .jybg >>> .el-textarea__inner {
    color: #c1c1c1;
    font-size: 1.2rem;
  }

  .gzjl {
    margin: 20px auto;
  }

  .gzjl >>> .el-textarea__inner {
    color: #c1c1c1;
    font-size: 1.2rem;
  }

  .upload-demo {
    margin-top: 40px;
    .el-button {
      width: 470px;
      height: 60px;
      background: #eff9ff;
      border: 1px solid #47aeea;
      border-radius: 5px;
    }
    .el-button >>> span {
      font-size: 1.2rem;
      color: #47aeea;
    }
  }
  .sumbit {
    width: 297px;
    padding: 10px 0;
    background: #f8ad17;
    border-radius: 5px;
    margin: 20px auto;
    cursor: pointer;
    text-align: center;
    span {
      font-size: 1.5rem;
      color: #fff;
    }
  }
}
@media screen and (max-width: $main-width) {
  .deliver-main {
    width: 100%;
    padding: 0 10px;
    .personal {
      flex-direction: column;
      .el-input {
        width: 100%;
        margin-top: 10px;
      }
    }
    .box-select {
      flex-direction: column;
      .el-select {
        width: 100%;
        margin-top: 10px;
      }
    }
    .upload-demo {
      width: 100%;
      .el-upload {
        width: 100%;
        .el-button {
          width: 100%;
        }
      }
    }
    .sumbit {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/resume.vue